export const GET_FACULTY_ITEMS = 'GET_FACULTY_ITEMS';
export const GET_UNIT_ITEMS = 'GET_UNIT_ITEMS';
export const GET_REPLICA = 'GET_REPLICA';

export function getFacultyItems(url) {
  // return the faculty staff (aka docenti)
  return {
    type: GET_FACULTY_ITEMS,
    request: {
      op: 'get',
      path: `${url}/@faculty`,
    },
  };
}

export function getUnitItems(url, aa) {
  // return the teaching units (aka insegnamenti)
  return {
    type: GET_UNIT_ITEMS,
    request: {
      op: 'get',
      path: `${url}/@units` + (aa ? `?aa=${aa}` : ''),
    },
  };
}

export function getReplicas(url) {
  // return the replica content
  return {
    type: GET_REPLICA,
    request: {
      op: 'get',
      path: `${url}/@replicas`,
    },
  };
}
